module.exports = __webpack_public_path__ + "static/lokalcommissionslogobeta2-3ff355f25b00c6303448a05b09e4df8e.png";